import axios from 'axios';

import { jwtDecode, JwtPayload } from 'jwt-decode';

import Cookies from 'universal-cookie';

const cookies = new Cookies();

export const setTokens = (accessToken: string, refreshToken: string) => {
    cookies.set('accessToken', accessToken);
    localStorage.setItem('refreshToken', refreshToken);
};

export const saveUserDetails = (firstname: string, lastname: string, email: string, phone: string, UID: string, role: any) => {
    cookies.set('UserDetails', JSON.stringify({
        firstname, lastname, email, phone, UID, role,
    }));
};

export const getUserAcc = (): any => {
    try {
        const data = cookies.get('UserDetails') as any;
        if (data) {
            if (typeof data === 'string') {

                return JSON.parse(data) as any;
            }

            return data;
        } else {
            return null;
        }
    } catch (error: any) {
        console.log('Failed to retrieve or parse UserDetails cookie:', error);
        return null;
    }
};

export const clearTokens = () => {
    cookies.remove('accessToken');
    localStorage.removeItem('refreshToken');
};

export const getAccessToken = (): string | null => {
    return cookies.get('accessToken');
};

export const getRefreshToken = (): string | null => {
    return localStorage.getItem('refreshToken');
};

export const getUserDetails = () => {
    const token = getAccessToken();

    // If token is missing or not a valid string, return null
    if (!token || typeof token !== "string") {
        return null;
    }

    try {
        const extractedToken = jwtDecode<JwtPayload & { username?: string }>(token);

        return {
            UID: extractedToken?.username ?? null,
        };
    } catch (error) {
        console.error("Invalid JWT token:", error);
        return null;
    }
};

export const isTokenExpired = (token: string): boolean => {
    if (!token) return true;
    const decoded = jwtDecode(token) as any;
    const now = Date.now() / 1000;
    return !decoded.exp || decoded.exp < now;
};

export const refreshToken = async (): Promise<boolean> => {
    const refreshToken = getRefreshToken() as any;
    if (!refreshToken) {
        clearTokens();
        return false;
    }

    try {
        const response = await axios.post('https://qvgt79a302.execute-api.ap-south-1.amazonaws.com/dev/Renew', {
            user: "",
            token: refreshToken
        });
        setTokens(response.data.accessToken, response.data.refreshToken);
        return true;
    } catch (error: any) {
        clearTokens();
        return false;
    }
};
